// extracted by mini-css-extract-plugin
module.exports = {"acceptPage":"acceptPage_acceptPage__z2_84","header":"acceptPage_header__2NV7M","content":"acceptPage_content__3RyHS","acceptMessage":"acceptPage_acceptMessage__2wU6j"};